import React from 'react'
import { Row, Col } from 'react-bootstrap'
import { StyledFirebaseAuth } from 'react-firebaseui'
import firebase from 'firebase'

interface SignupFormSocialButtonsProps {
  uiConfig: firebaseui.auth.Config
}

const SignupFormSocialButtons: React.FC<SignupFormSocialButtonsProps> = ({
  uiConfig
}) => {
  return (
    <div data-testid="signup-form-social-buttons">
      <Row lg={6} className="mx-auto pt-4">
        <Col className="mx-auto text-center">
          <span>or</span>
        </Col>
      </Row>
      <Row>
        <Col>
          <StyledFirebaseAuth
            uiConfig={uiConfig}
            firebaseAuth={firebase.auth()}
          />
        </Col>
      </Row>
    </div>
  )
}

export default SignupFormSocialButtons
